// infcode_change - new file
import { createHash } from "node:crypto"
import { isRecord } from "@/util/record"
import type { LoginErrorCode } from "./types"

export function loginStateHash(state: string | undefined) {
  return state ? createHash("sha256").update(state).digest("hex") : undefined
}

export function authLogOrigin(raw: string) {
  try {
    return new URL(raw).origin
  } catch {
    return "invalid-url"
  }
}

// 不记录 message/stack：网络和 JSON 解析异常可能夹带 URL、响应体或凭证。
export function authErrorDetails(error: unknown) {
  const code = isRecord(error) ? error.code : undefined
  const cause = isRecord(error) ? error.cause : undefined
  const causeCode = isRecord(cause) ? cause.code : undefined
  return {
    errorName: error instanceof Error ? error.name : typeof error,
    errorCode: typeof code === "string" || typeof code === "number" ? code : undefined,
    causeCode: typeof causeCode === "string" || typeof causeCode === "number" ? causeCode : undefined,
  }
}

// 只记录提示原因，保留原异常对象和业务返回语义。
const failures = new WeakMap<object, LoginErrorCode>()
export function recordLoginFailure(error: unknown, code: LoginErrorCode) {
  if (error && typeof error === "object") failures.set(error, code)
}
export function loginFailureCode(error: unknown): LoginErrorCode {
  if (error && typeof error === "object") {
    const known = failures.get(error)
    if (known) return known
  }
  return error instanceof Error && error.name === "TimeoutError" ? "login_timeout" : "login_failed"
}
